import { BlogPostsPageQueryDocument, type BlogPostsPageQueryQuery } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export interface GetBlogPostsParams {
  page?: number;
  pageSize?: number;
  theme?: string;
}

export async function getBlogPostsPageData(
  params?: GetBlogPostsParams,
): Promise<BlogPostsPageQueryQuery['blogPosts']> {
  const { data } = await ApolloClient.query({
    query: BlogPostsPageQueryDocument,
    variables: {
      page: params?.page || 1,
      pageSize: params?.pageSize || 7,
      theme: params?.theme,
    },
    errorPolicy: 'all',
  });

  return data?.blogPosts;
}
